import React from 'react';
// import theme from './HistoryLogModal.module.scss';
import { Modal, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import HistoryLogTable, { HistoryLogProps } from './HistoryLogTable';
import { Button } from '@/components/Buttons';
import { Trans } from '@lingui/react/macro';

interface HistoryLogModalProps extends HistoryLogProps {
    isOpen: boolean;
    toggle(): void;
}

const HistoryLogModal = ({ isOpen, toggle, ...rest }: HistoryLogModalProps) => {
    if (!isOpen) return null;

    return (
        <Modal onClose={toggle} closeOnEscape enableCloseButton size="auto" toggle={toggle} isOpen={isOpen}>
            {/* <ModalHeader></ModalHeader> */}
            <ModalBody>
                <HistoryLogTable {...rest} />
            </ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={toggle}>
                    <Trans>Close</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default HistoryLogModal;
